<template>
  <div class="card">
    <div class="card-header">
      <h4 class="mb-0">
        {{ $t('aucPrices.qiymtlr') }}
      </h4>
    </div>
    <div class="card-body">
      <div
        v-if="canOfferStatus==='yes'"
        class="mb-3"
      >
        <form @submit.prevent="addPrice">
          <div class="input-group  mb-3">
            <input
              v-model="requestNewPrice"
              class="form-control"
              type="number"
              required
              :placeholder="$t('aucPrices.qiymt')"
              step="0.01"
            >
            <div class="input-group-append">
              <div class="input-group-text">
                {{ $t('newAUCRequest.azn') }}
              </div>

              <button
                class="btn   btn-success mr-2"
                type="submit"
              >
                <span>{{ $t('aucPrices.gndr') }}</span>
              </button>
            </div>
          </div>
        </form>
        <div class="p-2 border border-danger text-danger">
          {{ $t('aucPrices.saxtaQiymtVernSatnalmaTrrfindnKnarladrlrBuZamanAdm') }}
        </div>
      </div>

      <table class="table table-striped">
        <tr
          v-for="(p,i) in requestPrices"
          :key="i"
          :class="[i===0?'bg-success lead font-weight-bold':'']"
        >
          <td>
            <strong class="badge bg-dark lead">{{ $t('itirak', {requestUserId: p.requestUserId}) }}</strong>
            <span
              v-if="requestUser && requestUser.userOrder === p.requestUserId "
              class="text-dark"
            >
              {{ $t('aucPrices.buSizsiniz') }}
            </span>
          </td>
          <td class="text-right">
            {{ $t('offerExtrasView.azn', {price: p.price}) }}
          </td>
          <td class="text-right">
            {{ $t('dashboardCompany.key', {moment: getMoment(p.logTime)}) }}
          </td>
        </tr>


        <tr
          v-if=" request.requestType==='AUC'"
          class="lead"
        >
          <td>
            {{ $t('aucPrices.balancQiymt') }}
          </td>
          <td class="text-right">
            <span class="badge bg-danger">{{ $t('aucPrices.azn', {startingPrice: requestExtras.startingPrice}) }}</span>
          </td>
        </tr>
      </table>


      <div
        v-if="requestPrices.length<1"
        class="text-danger my-3"
      >
        {{ $t('aucPrices.soruIlBalTklifYoxdur') }}
      </div>
    </div>
  </div>
</template>
<script>
import {sendPrice} from "@/repositories/GeneralDataRepository";
import {mapState} from "vuex";
import moment from "moment";

export default {
  name: 'AUCPrices',
  props: {
    canOfferStatus: {},
    request: {},
    requestExtras: {},
    requestPrices: {},
    requestUser: {}
  },
  data() {
    return {
      requestNewPrice: '',
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token
    })
  },
  methods: {
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    addPrice() {
      sendPrice(this.token, this.request.id, this.requestNewPrice).then(data => {
        if (data.code === 200) {
          this.$emit('refresh');
          this.requestNewPrice = '';
        } else if (data.code === 403) {
          let message = data.message;
          if (data.errorCode === 'you_blocked_but_company_can_join') {
            message = this.$t("aucPrices.blockedOut");
          } else if (data.errorCode === 'you_blocked') {
            message = this.$t("aucPrices.youBlocked");
          }

          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: message,
            icon: 'error'
          })
        } else if (data.code === 406) {
          let message = data.message;
          if (data.errorCode === 'price_is_lower') {
            message = this.$t("aucPrices.lower");
          } else if (data.errorCode === 'price_is_lower_starting') {
            message = this.$t("aucPrices.lowerStart");
          } else if (data.errorCode === 'price_is_higher') {
            message = this.$t("aucPrices.upperStart");
          }

          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: message,
            icon: 'error'
          })
        } else if (data.code === 409) {

          let message = data.message;

          if (data.errorCode === 'company_already_participating') {
            message = this.$t("aucPrices.fromYourCompany") + data.user + this.$t("aucPrices.artiqIstirak");
          } else if (data.errorCode === 'user_already_participating') {
            message = this.$t("aucPrices.you") + data.company + this.$t("aucPrices.istirakEdirsiz");
          }

          this.$swal({
            title: `Diqqət (${data.code})`,
            text: `${message}`,
            icon: 'error'
          })
        } else {
          this.$swal({
            title: `Xəta ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      });
    },
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>